import { application } from "./application"

// Controllers sob demanda: o pack principal não leva agenda, gráficos nem inbox.
const context = require.context(".", true, /_controller\.js$/, "lazy")

const loading = new Set()
const registered = new Set()

function identifierForContextKey(key) {
  const logicalName = (key.match(/^(?:\.\/)?(.+)(?:[_-]controller\..+?)$/) || [])[1]
  if (!logicalName) return null
  return logicalName.replace(/_/g, "-").replace(/\//g, "--")
}

const controllersByIdentifier = new Map()
context.keys().forEach((key) => {
  const identifier = identifierForContextKey(key)
  if (identifier) controllersByIdentifier.set(identifier, key)
})

function loadController(identifier) {
  if (!identifier || loading.has(identifier) || registered.has(identifier)) return

  const key = controllersByIdentifier.get(identifier)
  if (!key) return

  loading.add(identifier)
  context(key)
    .then((module) => {
      if (registered.has(identifier)) return
      application.register(identifier, module.default)
      registered.add(identifier)
    })
    .catch((error) => {
      loading.delete(identifier)
      console.error(`Falha ao carregar o controller "${identifier}"`, error)
    })
}

function loadFromElement(element) {
  if (!element?.getAttribute) return
  const names = element.getAttribute("data-controller")
  if (!names) return
  names.split(/\s+/).forEach((name) => loadController(name))
}

function loadFromTree(root) {
  loadFromElement(root)
  if (!root.querySelectorAll) return

  // Bolhas da inbox: só procura data-controller (áudio/figurinha). Evita
  // varrer dezenas de nós de texto/mídia a cada clique.
  if (root.matches?.(".wa-inbox-bubble-row, #whatsapp_live_messages, #whatsapp_archived_messages")) {
    root.querySelectorAll("[data-controller]").forEach(loadFromElement)
    return
  }

  root.querySelectorAll("[data-controller]").forEach(loadFromElement)
}

loadFromTree(document.documentElement)

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === "attributes" && mutation.attributeName === "data-controller") {
      loadFromElement(mutation.target)
    }
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) loadFromTree(node)
    })
  }
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["data-controller"]
})
